import axios from 'axios'
import { Message } from 'element-ui'
import auth from '@/utils/auth'
import router from '@/router'; // 引入router实例
// create an axios instance
const service = axios.create({
  baseURL:'/dlbzgl/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})


// request interceptor 请求拦截器
service.interceptors.request.use(config => {
    if (auth.hasToken()) {
      config.headers['Authorization'] = auth.getToken();
    }else {
      // router.push({path: '/login'})
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {


    if (response.headers['captcha-key']){
      console.log(response.headers['captcha-key'],789)
      sessionStorage.setItem('captcha-key',response.headers['captcha-key'])

    }
    const res = response.data
    if (res.errorCode == 2002){  // 登录过期
      Message({message: res.errorMsg, type: 'error', duration: 4 * 1000})
      setTimeout(()=>{
        sessionStorage.clear()
        localStorage.clear()
        router.push({path:'/login'})
      })
    }


    else {
      return res
    }
  },
  error => {
    Message({message: error.message, type: 'error', duration: 5 * 1000})
    return Promise.reject(error)
  }
)



export default service



// WEBPACK FOOTER //
// ./src/landmark-admin/utils/request.js